<template>
     <el-dialog class="gysInfo-dialog-box" :visible.sync="openDialog" width="calc(100% - 40px)" :title="'供应商信息'" :close-on-click-modal="false">
         <div class="dialog-info-box">
            <gysInfo v-if="openDialog" :pageFlag="pageFlag" :gysId="gysId" />
         </div>
         <span slot="footer" class="dialog-footer">
            <el-button type="primary" v-if="checkRole('gys_audit')" @click="auditOpen" :disabled="status!=1" size="small">审核</el-button>
            <el-button @click="openDialog = false" size="small">关闭</el-button>
        </span>
        <AuditGys ref="AuditGysRef" @callback="AuditGysCallback" />
     </el-dialog>
</template>
<script>
import gysInfo from '../../views/gys/gysInfo'
import AuditGys from '../../views/gysmng/audit/AuditGys'
export default {
    data() {
        return {
            pageFlag:'',
            openDialog:false,
            gysId:'',
            status:'',
        };
    },
    created() {

    },
    computed: {
    },
    methods: {
        show(flag,obj){
            this.pageFlag = flag;
            this.gysId = obj.id;
            this.status = obj.status;
            this.openDialog = true;
        },
        auditOpen(){
            this.$refs.AuditGysRef.auditOpen({id:this.gysId})
        },
        AuditGysCallback(obj){
            this.openDialog = false;
            this.$emit('callback',{type:'audit',back:obj.type})
        },
    },
    components: {
        gysInfo,AuditGys
    },
};
</script>

<style lang="scss">
    .gysInfo-dialog-box{
        .el-dialog{
            margin-top: 20px!important;
            margin-bottom: 20px!important;
            .dialog-info-box{
                height: calc(100vh - 160px);
                overflow-y: auto;
            }

        }
    }
</style>
